export default function abbreviateNumber(num = 0, fixed = 0) {
  const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];

  // what tier? (determines SI symbol)
  const tier = Math.floor(Math.log10(Math.abs(num)) / 3);

  // if zero, we don't need a suffix
  if (tier === 0) return num;

  // get suffix and determine scale
  const suffix = SI_SYMBOL[tier];
  const scale = 10 ** (tier * 3);

  // scale the num
  const scaled = num / scale;

  // format num and add suffix
  return scaled.toFixed(fixed) + suffix;
}
